module.exports = __webpack_public_path__ + "static/media/design-cover.32a289ee.png";